import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Button from 'components/Button';
import messages from 'utils/messages';
import EditPencil from 'images/common/edit-pencil';
import OutsideClickHandler from 'react-outside-click-handler';
import classNames from 'classnames';
import { renderCardContentType } from './utils';
import { VuiDropDown } from '@topkamera/viso-ui';

class Card extends Component {
  state = {
    showDropdown: false,
    dropDownMenuOpen: false,
  };

  toggleAction = (e) => {
    this.setState({ showDropdown: true });
  };

  closeMenu = () => {
    this.setState({ showDropdown: false });
  };

  onActionOutsideClick = () => {
    this.setState({ showDropdown: false });
  };

  render() {
    const { noGrid, secondaryContent, id, titleClass, height, dropDownMenu } = this.props;

    return (
      <>
        <div className={classnames('content-box', this.props.className, {
          card_loading: this.props.isLoading,
        })}
          tabIndex="1"
          style={{ height }}
        >
          {this.props.customMenuAction}
          {
            this.props.customText
            && (
              <Button
                id={id}
                className={classnames('overview__edit', `overview__edit_${this.props.color}`, { [this.props.color]: this.props.color })}
                onClick={this.props.action}
              >
                {this.props.customText}
              </Button>
            )
          }
          {
            (this.props.menu || this.props.onEdit)
            && (
              <span className="actions2">
                {this.props.menu && (
                  this.props.dropDownMenu ? (
                    // New system: VuiDropDown handles both trigger button and dropdown
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '9px' }}
                      className={classNames('content-box__dropdown-menu', {
                        'content-box__dropdown-menu--visible': this.state.dropDownMenuOpen
                      })}
                      onMouseDown={(e) => e.stopPropagation()}
                    >
                      <VuiDropDown
                        {...this.props.dropDownMenu}
                        onOpen={(value) => this.setState({ dropDownMenuOpen: value })}
                        elementId={this.props.dropDownMenu.elementId || 'popoverRoot'}
                      />
                    </div>
                  ) : (
                    // Old system: Button + children dropdown
                    <>
                      <div onMouseDown={(e) => {
                        e.stopPropagation(); // Prevents drag start
                      }}
                      >
                        <Button
                          id={id}
                          className={classnames('overview__edit', `overview__edit_${this.props.color}`, {
                            [this.props.color]: this.props.color,
                            actions__button: this.props.menu === 'dot'
                          })}
                          onClick={this.toggleAction}
                        >
                          {this.props.menu === 'dot' ? '' : this.props.menu}
                        </Button>
                      </div>
                      {this.props.children && (
                        <OutsideClickHandler onOutsideClick={this.onActionOutsideClick}>
                          <div
                            onMouseDown={(e) => {
                              e.stopPropagation(); // Prevents drag start
                            }}
                            className={classnames('actions__dropdown', {
                              actions__dropdown_visible: this.state.showDropdown,
                            })}
                          >
                            {this.state.showDropdown
                              && React.Children.map(this.props.children, (child) => {
                                if (child) {
                                  return React.cloneElement(child, {
                                    closeMenu: this.closeMenu,
                                    onToogleMenu: this.toggleAction,
                                  });
                                }
                              })}
                          </div>
                        </OutsideClickHandler>
                      )}
                    </>
                  )
                )}
                {this.props.onEdit && (
                  <Button
                    id={id}
                    className={classnames('overview__edit', `overview__edit_${this.props.color}`)}
                    onClick={this.props.onEdit}
                  >
                    <EditPencil />
                    <FormattedMessage {...messages.edit} />
                  </Button>
                )}
              </span>
            )
          }

          {this.props.title &&
            <div className={classNames("overview__title", {
              [titleClass]: titleClass
            })}>
              {this.props.title}
            </div>
          }
          {this.props.subTitle
            && <div className="overview__subtitle">{this.props.subTitle}</div>
          }
          {noGrid && this.props.content}
          {!noGrid && (
            <div className={classnames("grid-row", {
              'width-100': this.props.has100Width
            })}>
              {this.props.content}
              {this.props.gridContent?.length > 0 && this.props.gridContent.map((col, index) => !col.hide &&
                <div
                  key={index}
                  className={classNames('grid-col overview__grid-content', col.width && `grid-col_${col.width}`, col.marginTop && 'overview__grid-content--margin-top')}
                >
                  {!col.hideLabel && col.label &&
                    <div
                      className={classNames("overview__label", col.labelSize && `overview__label--${col.labelSize}`)}
                    >
                      {col.label}
                    </div>
                  }
                  {col.nestedItems ?
                    <div className={col.nestedClass}>
                      {col.nestedItems.map((nested, index) =>
                        <div key={index} className={classNames("overview__value overview__value--block", nested.type === 'gridList' && 'overview__value--grid-list', nested.overflowVisible && 'overflow')}>{renderCardContentType(nested, this.props.color)}</div>)}
                    </div>
                    :
                    <div className={classNames("overview__value overview__value--block", col.type === 'gridList' && 'overview__value--grid-list', col.overflowVisible && 'overflow', col.className)}>{renderCardContentType(col, this.props.color)}</div>
                  }
                </div>
              )}
            </div>
          )
          }
          {secondaryContent && (
            <div className={classnames("grid-row", {
              'width-100': this.props.has100Width
            })}>
              {this.props.secondaryContent}
            </div>
          )
          }
        </div>
      </>

    );
  }
}

Card.propTypes = {
  color: PropTypes.string,
  subTitle: PropTypes.any,
  customText: PropTypes.any,
  action: PropTypes.any,
  onEdit: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  content: PropTypes.node,
  className: PropTypes.string,
};

Card.defaultProps = {
  color: 'accent0',
  className: 'overview'
};

export default Card;
